import { useState } from "react";
import { Box, Typography, IconButton, Collapse } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import globalStyles from "../../global";

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const styles = {
    container: {
      borderBottom: "1px solid",
      borderColor: "grey.200",
      py: 0.5,
    },
    button: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      py: { xs: 2, sm: 2.5 },
      px: { xs: 1, sm: 2 },
      textAlign: "left",
      border: "none",
      bgcolor: "transparent",
      cursor: "pointer",
    },
    questionText: {
     fontSize: { sm: "18px", xs: "14px" },
      color: "grey.700",
      pl: 0,
      pr: 2,
      textAlign: "left",
      fontFamily: globalStyles.fonts.primary,
    },
    icon: {
      color: globalStyles.colors.army_green,
      transition: "transform 0.2s",
      transform: isOpen ? "rotate(180deg)" : "none",
    },
    answerContainer: {
      px: { xs: 1, sm: 2 },
      pb: isOpen ? { xs: 2, sm: 2.5 } : 0,
    },
    answerText: {
     fontSize: { sm: "18px", xs: "14px" },
      color: "grey.600",
      textAlign: "left",
      fontFamily: globalStyles.fonts.primary,
    },
  };

  return (
    <Box sx={styles.container}>
      <Box
        component="button"
        onClick={() => setIsOpen(!isOpen)}
        sx={styles.button}
      >
        <Typography sx={styles.questionText}>{question}</Typography>
        <IconButton size="small" sx={styles.icon}>
          <KeyboardArrowDownIcon />
        </IconButton>
      </Box>
      <Collapse in={isOpen}>
        <Box sx={styles.answerContainer}>
          <Typography sx={styles.answerText}>{answer}</Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

const FAQSection = () => {
  const { t } = useTranslation();

  const styles = {
    container: {
      py: 10,
      px: 2,
      backgroundColor: "#F2F3F0",
      // mb: "4%",
      // mt: "7%",
    },
    wrapper: {
      maxWidth: "800px",
      mx: "auto",
    },
    title: {
      fontWeight: "bold",
      textAlign: "center",
      color: globalStyles.colors.army_green,
      mb: 4,
      fontFamily: globalStyles.fonts.primaryUAE,
      textTransform: "uppercase",
       fontSize: { md: "40px", sm: "28px", xs: "24px" },
    },
    faqContainer: {
      bgcolor: "white",
      borderRadius: "15px",
      overflow: "hidden",
    },
  };

  const faqItems = Array.from({ length: 6 }, (_, i) => ({
    question: t(`faqs1.items.${i}.question`),
    answer: t(`faqs1.items.${i}.answer`),
  }));

  return (
    <Box sx={styles.container}>
      <Box sx={styles.wrapper}>
        <Typography variant="h1" sx={styles.title}>
          {t("faqService.title")}
        </Typography>
        <Box sx={styles.faqContainer}>
          {faqItems.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FAQSection;
